import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-259">
      <div className="max-w-3xl mx-auto text-center" data-id="element-260">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-10" data-id="element-261">
          Si sos docente de Biología en secundaria,
          <br data-id="element-262" />
          <span className="text-[#00E676]" data-id="element-263">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-4 text-left mb-12" data-id="element-264">
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-265">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-266">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-267">
              Domingo a la noche buscando actividades en internet que nunca
              quedan bien ni están alineadas al diseño curricular de tu
              provincia
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-268">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-269">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-270">
              Llegás al lunes con algo que "más o menos sirve" y durante la
              clase te das cuenta que le falta estructura, cierre y evaluación
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-271">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-272">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-273">
              Tenés que armar planificaciones para jefatura o inspección a las
              corridas, la noche anterior, sin saber si están bien formuladas
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-274">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-275">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-276">
              Tus evaluaciones son siempre las mismas o siempre inventadas
              porque no tenés un banco de instrumentos serios con solucionario
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-277">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-278">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-279">
              Cuando el tema es difícil —genética, homeostasis, evolución— no
              sabés cómo explicarlo sin perder al curso en el camino
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-280">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-281">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-282">
              Tenés alumnos con PPI o dificultades de aprendizaje y no tenés
              material adaptado — así que improvisás o los dejás de lado sin
              querer
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-283">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-284">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-285">
              Trabajás de lunes a viernes, llegás al fin de semana agotado/a y
              el domingo volvés a empezar el ciclo
            </p>
          </div>
        </div>

        <p className="text-[#00E676] text-2xl sm:text-3xl font-black mb-8" data-id="element-286">
          ¿Cuántos domingos más vas a perder haciendo lo mismo?
        </p>

        {/* Green divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#00E676] to-transparent w-full" data-id="element-287" />
      </div>
    </section>;
}